import { render } from "./PorQueNosotros.vue?vue&type=template&id=aa9af6c2"
import script from "./PorQueNosotros.vue?vue&type=script&lang=js"
export * from "./PorQueNosotros.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__